import { type JSX } from "react";
import type { ISvgIcon } from "@/types";

export function ICBNBNet({
  width = "42",
  height = "42",
  className = "",
}: ISvgIcon): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_396_26095)">
        <path
          d="M0 4.8C0 2.14903 2.14903 0 4.8 0H27.2C29.851 0 32 2.14903 32 4.8V27.2C32 29.851 29.851 32 27.2 32H4.8C2.14903 32 0 29.851 0 27.2V4.8Z"
          fill="#14151A"
        />
        <path
          d="M9.98323 8.23084L16.0004 4.7998L22.0175 8.23084L19.8052 9.49836L16.0004 7.33483L12.1952 9.49836L9.98323 8.23084ZM22.0175 12.5579L19.8052 11.2904L16.0004 13.454L12.1952 11.2904L9.98323 12.5579V15.0929L13.7881 17.2564V21.5835L16.0004 22.8511L18.2126 21.5835V17.2564L22.0175 15.0929V12.5579ZM22.0175 19.4199V16.8848L19.8052 18.1524V20.6875L22.0175 19.4199ZM23.588 20.316L19.7832 22.4793V25.0144L25.8003 21.5835V14.7215L23.588 15.9888V20.316ZM21.3759 10.3943L23.588 11.6618V14.1969L25.8003 12.9294V10.3943L23.588 9.12684L21.3759 10.3943ZM13.7881 23.3973V25.9324L16.0004 27.1999L18.2126 25.9324V23.3973L16.0004 24.6648L13.7881 23.3973ZM9.98323 19.4199L12.1952 20.6875V18.1524L9.98323 16.8848V19.4199ZM13.7881 10.3943L16.0004 11.6618L18.2126 10.3943L16.0004 9.12684L13.7881 10.3943ZM8.41244 11.6618L10.6247 10.3943L8.41244 9.12684L6.2002 10.3943V12.9294L8.41244 14.1969V11.6618ZM8.41244 15.9888L6.2002 14.7215V21.5835L12.2176 25.0144V22.4793L8.41244 20.316V15.9888Z"
          fill="#F0B90B"
        />
      </g>
      <defs>
        <clipPath id="clip0_396_26095">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
